// @flow
import styled from 'styled-components';

import { TYPE_SCALE_F3 } from 'styles/type-scale';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { CLARK_SECONDARY } from 'styles/colors';
import { SPACING_LARGE } from 'styles/spacing';

export const Paragraph = styled.p`
  ${TYPE_SCALE_F3};
  ${FONT_WEIGHT_100};
  color: ${CLARK_SECONDARY};
  line-height: 1.5;
`;

export const Wrapper = styled.header`
  text-align: ${props => props.textAlign};
  padding-bottom: ${SPACING_LARGE};
`;



// WEBPACK FOOTER //
// ./src/components/payer/splash/welcome-text/styles.js